import { render, staticRenderFns } from "./SwalRemoveCalciatoreAssegnato.vue?vue&type=template&id=7b7bbb73&"
import script from "./SwalRemoveCalciatoreAssegnato.vue?vue&type=script&lang=js&"
export * from "./SwalRemoveCalciatoreAssegnato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b7bbb73')) {
      api.createRecord('7b7bbb73', component.options)
    } else {
      api.reload('7b7bbb73', component.options)
    }
    module.hot.accept("./SwalRemoveCalciatoreAssegnato.vue?vue&type=template&id=7b7bbb73&", function () {
      api.rerender('7b7bbb73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/swal/SwalRemoveCalciatoreAssegnato.vue"
export default component.exports